// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography, Backdrop } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import ReceiptLine from "./ReceiptLine";
// Constants
import { RECEIPT_LINES_TABLE_HEADS } from "../../../configs/TableHeaderConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
import SpinService from "../../../services/SpinService";
import GoDialog from "../../../common/GoDialog/GoDialog";

import { Form, Formik } from "formik";
import { post, put, del } from "../../../services/FetchHelper";
import GoInLineTable from "../../../common/GoInLineTable/GoInLineTable";
import { receiptTypes } from "./Receipt.utils";
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
import toast from "react-hot-toast";

const ReceiptLines = ({ feeType = "School Transport", receiptHeader, receiptHeaderId, receiptLines, reload, outstanding_balance }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [receiptLineState, setReceiptLineState] = useState(receiptTypes[feeType].state);
    const [allReceiptLines, setAllReceiptLines] = useState([]);
    const [receiptLineId, setReceiptLineId] = useState(undefined);
    const [open, setOpen] = useState(false);
    const [confirm, setConfirm] = useState(false);


    const onClose = () => {
        setReceiptLineState(receiptTypes[feeType].state);
        setOpen(false);
        reload();
    };

    const addNew = () => {
        if (allReceiptLines.find((item) => item.rowAction !== undefined && (item.rowAction === "new" || item.rowAction === "edit")) === undefined) {
            const nr = { ...receiptTypes[feeType].state, rowAction: 'new' };
            setReceiptLineState(nr);
            if (allReceiptLines === false) {
                setAllReceiptLines([nr])
            } else {
                setAllReceiptLines([...allReceiptLines, nr])
            }
        }
    };

    const onAction = (item, action) => {
        if (action === "edit" && allReceiptLines.find((item) => item.rowAction !== undefined && (item.rowAction === "new" || item.rowAction === "edit")) === undefined) {
            setReceiptLineId(item.id);
            setReceiptLineState(allReceiptLines.find((row) => row.id === item.id));
            setAllReceiptLines((prevFormFields) => prevFormFields.map(row => row.id === item.id ? { ...row, rowAction: 'edit' } : row));
        }
        if (action === "delete") {
            setReceiptLineId(item.id);
            setConfirm(true);
            return;
        }
    }

    const handleSubmit = async (values) => {
        if (values.total_amount > outstanding_balance && feeType === "School Transport") {
            toast.error("The provided amount is higher than the outstanding balance.")
            return
        }
        spinService.on();
        const isNewReceiptLine = values.id === undefined;
        values.receipt_header_id = receiptHeaderId;
        const url = isNewReceiptLine ? EntityConstants.RECEIPT_LINES : EntityConstants.RECEIPT_LINES + `/${values.id}`;
        const method = isNewReceiptLine ? post : put;
        const response = await method(url, { receipt_line: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewReceiptLine ? MessageContants.RECEIPT_LINE_CREATED : MessageContants.RECEIPT_LINE_UPDATED);
            onClose();
        }
    };

    const handleClose = async (res) => {
        if (res) {
            spinService.on();
            const response = await del(EntityConstants.RECEIPT_LINES + `/${receiptLineId}`);
            if (response.status === 200) {
                toast.success(MessageContants.RECEIPT_LINE_DELETED);
            }
            reload();
            spinService.off();
        } else {
            setReceiptLineId(undefined);
        }
        setConfirm(false);
    };


    useEffect(() => {
        setAllReceiptLines(receiptLines);
    }, [receiptLines]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Receipt Lines
                    </Typography>
                    {permissions.has(PermissionConstants.RECEIPT_CREATE) &&
                        <Button
                            disabled={outstanding_balance <= 0}
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={addNew}
                        >
                            New Line
                        </Button>
                    }
                </Stack>
                <Card>
                    <Formik
                        enableReinitialize
                        initialValues={receiptLineState}
                        validationSchema={receiptTypes[feeType].schema}
                        onSubmit={(values) => handleSubmit(values)}
                    >
                        {({
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleSubmit,
                        }) => (

                            <Form noValidate onSubmit={handleSubmit}>
                                <GoInLineTable
                                    tableHeads={receiptTypes[feeType].tableHeaders}
                                    tableDatas={allReceiptLines}
                                    onAction={(row, action) => onAction(row, action)}
                                    editRowId={receiptLineId}
                                    formElement={<ReceiptLine
                                        values={values}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        feeType={feeType}
                                        receiptHeaderId={receiptHeaderId}
                                        id={receiptLineId}
                                        onClose={() => onClose()}
                                    />}
                                />
                            </Form>
                        )}
                    </Formik>
                </Card>
            </Container>
            <GoDialog
                open={confirm}
                title=""
                content="Are you sure you want to delete?"
                positive="Yes"
                negative="No"
                handleClose={(res) => handleClose(res)}
            />
        </React.Fragment>
    );
}

export default ReceiptLines;